/**
 * nwsAlertsService.ts — مضلّعات تحذيرات هيئة الأرصاد الأمريكية (NWS).
 *
 * المصدر `api.weather.gov` مِلك عام (حكومة أمريكية اتحادية): بلا رخصة، بلا مفتاح،
 * وبلا قيد على الاستعمال التجاري. لكنّه يُطلب عبر وسيطنا لا مباشرةً — راجع
 * `App\Services\NwsAlertsService` للأسباب الثلاثة (ترويسة User-Agent التي لا يملك
 * المتصفّح ضبطها، وحجم الردّ، والكاش المشترك).
 */
import axios from 'axios';
import type { FeatureCollection } from 'geojson';
import { apiBaseUrl } from './apiBase';

export interface AlertProperties {
    id: string | null;
    event: string;
    /** لون الحدث — يُحسب في الخادم فيبقى الجدول في مكان واحد. */
    color: string;
    severity: string | null;
    urgency: string | null;
    headline: string | null;
    sender: string | null;
    onset: string | null;
    expires: string | null;
    summary: string | null;
}

export type AlertCollection = FeatureCollection<GeoJSON.Geometry, AlertProperties>;

const EMPTY: AlertCollection = { type: 'FeatureCollection', features: [] };

/**
 * يُرجع `null` عند تعذّر الجلب — لا مجموعةً فارغة.
 *
 * الفارق هنا أثقل منه في أي طبقة أخرى: المجموعة الفارغة تعني «لا تحذيرات نشطة»
 * فتمحو الطبقة، وتحذير الإعصار القمعي الممحوّ لعثرة شبكة أسوأ من تحذير متأخّر دقيقة.
 * والخادم يردّ 503 لا 200-فارغة عند فشله لهذا السبب نفسه.
 */
export async function getActiveAlerts(): Promise<AlertCollection | null> {
    try {
        const { data } = await axios.get<AlertCollection>(`${apiBaseUrl}/alerts/active`, { timeout: 20000 });
        if (data?.type !== 'FeatureCollection' || !Array.isArray(data.features)) return null;
        return data;
    } catch {
        return null;
    }
}

export const EMPTY_ALERTS = EMPTY;
